import JSZip from "jszip";

export async function loadWord(file) {
    const buffer = await file.arrayBuffer();

    const zip = await JSZip.loadAsync(buffer);

    const readXml = async (path) => {
        const xmlFile = zip.file(path);

        if (!xmlFile) return null;

        return await xmlFile.async("text");
    };

    const documentXml = await readXml("word/document.xml");
    const stylesXml = await readXml("word/styles.xml");
    const relsXml = await readXml("word/_rels/document.xml.rels");

    return {
        zip,
        documentXml,
        stylesXml,
        relsXml
    };
}
export function parseXml(xmlString) {

    if (!xmlString) return null;

    const parser = new DOMParser();

    return parser.parseFromString(
        xmlString,
        "application/xml"
    );

}
export function getParagraphs(xmlDoc){

    return Array.from(
        xmlDoc.getElementsByTagName("w:p")
    );

}
export function getParagraphText(paragraph) {
    const texts = paragraph.getElementsByTagName("w:t");

    let value = "";

    for (let i = 0; i < texts.length; i++) {
        value += texts[i].textContent;
    }

    return value.trim();
}
export function getParagraphType(paragraph) {

    const style = paragraph.getElementsByTagName("w:pStyle")[0];

    if (!style) {
        return {
            type: "paragraph",
            level: 0
        };
    }

    const styleName =
        style.getAttribute("w:val") ||
        style.getAttribute("val");

    if (!styleName) {
        return {
            type: "paragraph",
            level: 0
        };
    }

    if (/^Heading\s*1$/i.test(styleName)) {
        return {
            type: "heading",
            level: 1
        };
    }

    if (/^Heading\s*2$/i.test(styleName)) {
        return {
            type: "heading2",
            level: 2
        };
    }

    if (/^Heading\s*[3-9]$/i.test(styleName)) {

        return {
            type: "heading",
            level: Number(
                styleName.replace("Heading", "")
            ) || 1
        };

    }

    return {
        type: "paragraph",
        level: 0
    };

}
export function hasImage(paragraph) {

    return (
        paragraph.getElementsByTagName("w:drawing").length > 0 ||
        paragraph.getElementsByTagName("w:pict").length > 0
    );

}
export function convertParagraphs(xmlDoc) {

    const paragraphs = getParagraphs(xmlDoc);

    const result = [];
    let idCounter = 0;

    const createId = () => `${Date.now()}-${++idCounter}`;

    paragraphs.forEach((paragraph) => {

        const text = getParagraphText(paragraph);

        const paragraphType = getParagraphType(paragraph);

        if (hasImage(paragraph)) {

            result.push({
                id: createId(),
                type: "image",
                value: "",
                alt: ""
            });

            result.push({
                id: createId(),
                type: "image-desc",
                value: ""
            });

            return;
        }

        if (!text) return;

        result.push({
            id: createId(),
            type: paragraphType.type,
            level: paragraphType.level,
            value: text
        });

    });

    return result;

}

function detectLanguage(text) {
    if (/[\uAC00-\uD7AF]/.test(text)) return "ko";
    if (/[\u3040-\u30FF]/.test(text)) return "ja";

    const vietnameseSpecificLetters = /[ăâđêôơưĂÂĐÊÔƠƯ]/;
    if (vietnameseSpecificLetters.test(text)) return "vi";

    const vietnameseWords = [
        "và", "của", "cho", "với", "tại", "trong", "khách", "sạn", "nhà", "hàng",
        "quán", "món", "ăn", "uống", "địa", "điểm", "khu", "vực", "hà nội", "hà nộ",
        "du khách", "lưu trú", "thưởng thức", "khám phá", "tiện ích", "xung quanh",
        "một số", "lựa chọn", "phù hợp", "nằm", "gần", "tầng", "hầm", "đường", "phố"
    ];
    const normalizedText = text.toLowerCase();
    const vietnameseWordScore = vietnameseWords.reduce(
        (score, word) => score + (normalizedText.includes(word) ? 1 : 0),
        0
    );

    const toneMarks = normalizedText.match(/[àáảãạằắẳẵặầấẩẫậèẻẽẹềếểễệìíỉĩịòóỏõọồốổỗộờớởỡợùúủũụừứửữựỳýỷỹỵ]/g) || [];
    if (vietnameseWordScore >= 1 && toneMarks.length >= 2) return "vi";

    const withoutMarks = normalizedText
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d");
    const unaccentedVietnamesePhrases = [
        "khach san", "nha hang", "dia diem", "ha noi", "du khach",
        "luu tru", "thuong thuc", "kham pha", "tien ich", "xung quanh",
        "mot so", "lua chon", "phu hop", "khu vuc", "am thuc", "do uong",
        "mon an", "quan an", "duong pho"
    ];
    const unaccentedWordScore = unaccentedVietnamesePhrases.reduce(
        (score, phrase) => score + (withoutMarks.includes(phrase) ? 1 : 0),
        0
    );

    if (unaccentedWordScore >= 1) return "vi";
    return "en";
}

export function convertMultilingualParagraphs(xmlDoc) {
    const result = { vi: [], en: [], ja: [], ko: [] };
    let idCounter = 0;
    const createId = () => `${Date.now()}-${++idCounter}`;

    getParagraphs(xmlDoc).forEach((paragraph) => {
        const text = getParagraphText(paragraph);
        const paragraphType = getParagraphType(paragraph);

        if (hasImage(paragraph)) {
            // share the same ids across languages so image blocks can be matched/copied cross-language
            const imageId = createId();
            const descId = createId();
            Object.keys(result).forEach((language) => {
                result[language].push({
                    id: imageId,
                    type: "image",
                    value: "https://azumayavietnam.com/image/",
                    alt: ""
                });
                result[language].push({ id: descId, type: "image-desc", value: "" });
            });
            return;
        }

        if (!text) return;

        const language = detectLanguage(text);
        result[language].push({
            id: createId(),
            type: paragraphType.type,
            level: paragraphType.level,
            value: text
        });
    });

    return result;
}
